import { render } from "./Favoritos.vue?vue&type=template&id=1fc1c92c&scoped=true"
import script from "./Favoritos.vue?vue&type=script&lang=js"
export * from "./Favoritos.vue?vue&type=script&lang=js"

import "./Favoritos.vue?vue&type=style&index=0&id=1fc1c92c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc1c92c"]])

export default __exports__